import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemDeleteAtom = createMutationAtomFactory(
  'settings.itemDelete',
  (params: { id: string }) => ({
    inventoryItemDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
